(function () {
  function initCleenyFaq(section) {
    if (!section || section.dataset.faqReady === 'true') return;
    section.dataset.faqReady = 'true';

    const items = Array.from(section.querySelectorAll('[data-faq-item]'));

    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;

        items.forEach(function (otherItem) {
          if (otherItem !== item && otherItem.open) {
            otherItem.open = false;
          }
        });
      });
    });
  }

  function initAllFaqs(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-cleeny-faq]').forEach(initCleenyFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllFaqs(document);
    });
  } else {
    initAllFaqs(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllFaqs(event.target);
  });
})();